import { useAuth } from 'hooks/useAuth';
import { useSessionStorage } from 'hooks/useSessionStorage';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkHRAPermission } from 'utils/checkFunctionalityPermission';
import {
	modalConfig,
	navbarMenuOptions,
	sidebarOptions,
} from './Layout.constants';

export type ModalType = 'password' | 'systemInfo' | null;

export const useLayout = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { signOut } = useAuth();
	const { getSessionStorage } = useSessionStorage();
	const sessionStorage: any = getSessionStorage('me');
	const parsedStorage = JSON.parse(sessionStorage);
	const [activeModal, setActiveModal] = useState<ModalType>(null);

	const sidebarItems = useMemo(() => {
		const isHRAItemVisible = checkHRAPermission();

		if (!isHRAItemVisible) {
			return sidebarOptions.filter((item) => item.label !== 'HRA');
		}

		return sidebarOptions;
	}, []);

	const sidebar = {
		onSelect: (url: any) => navigate(url),
		activePath: location.pathname,
		menuOptions: sidebarItems,
	};

	const handleSignOut = () => {
		signOut();
		navigate('/login');
	};

	const menuActions: Record<string, () => void> = {
		signout: handleSignOut,
		password: () => setActiveModal('password'),
		systemInfo: () => setActiveModal('systemInfo'),
		user: () => navigate('/users'),
	};

	const handleSelectItem = (type: string) => {
		menuActions[type]?.();
	};

	const navbar = {
		onSelect: handleSelectItem,
		menuLabel: parsedStorage.name,
		supportContact: 'https://wa.me/+5215593377181',
		menuOptions: navbarMenuOptions,
		logo: parsedStorage?.company?.logo,
	};

	const handleCloseModal = () => setActiveModal(null);
	const activeModalConfig = activeModal ? modalConfig[activeModal] : null;

	return {
		sidebar,
		navbar,
		activeModalConfig,
		handleCloseModal,
	};
};
